module.exports = __webpack_public_path__ + "media/evolve/assets/icons/floorplans/pointer-28ecf173cfe2696968b8489d298afb2e.svg";